import React, { useEffect } from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import NumberFormat, { NumberFormatValues } from 'react-number-format';
import { useFormikContext } from 'formik';
import styled from 'styled-components';

const InputField = styled(TextField)`
  max-width: 500px;
  width: 100%;
`;

interface InputProps {
  name: string;
  type: string;
  value?: string | number;
  startUnit?: string;
  unit?: string;
  max?: number;
  min?: number;
  disabled?: boolean;
  isAllowedZero?: boolean;
  error?: boolean;
}

export const Input: React.FC<InputProps & TextFieldProps> = (props) => {
  const { setFieldValue } = useFormikContext();

  const handleChange = (value?: string | number) => {
    setFieldValue(props.name, value);
  };

  useEffect(() => {
    if (!props.isAllowedZero && props.value === 0) {
      setFieldValue(props.name, undefined);
    }
  }, [props.value, props.isAllowedZero, setFieldValue]);

  return (
    <InputField
      {...props}
      onChange={(e) => {
        const value = e.currentTarget.value;
        if (props.type === 'number') {
          handleChange(
            value && parseInt(value) !== 0 ? parseInt(value) : undefined
          );
        } else {
          handleChange(value);
        }
      }}
      InputProps={{
        inputProps: {
          maxLength: props.max,
          max: props.max,
          min: props.min || 0,
          arrowzero: props.isAllowedZero,
        },
        startAdornment: props.startUnit && (
          <InputAdornment position="start">{props.startUnit}</InputAdornment>
        ),
        endAdornment: props.unit && (
          <InputAdornment position="end">{props.unit}</InputAdornment>
        ),
        inputComponent:
          props.type === 'number' ? (NumberFormatCustom as any) : undefined,
      }}
    />
  );
};

interface NumberFormatCustomProps extends InputProps {
  inputRef: (instance: NumberFormat | null) => void;
  onChange: (event: { currentTarget: { name: string; value: string } }) => void;
  arrowzero: boolean;
}
const NumberFormatCustom = React.forwardRef((props: NumberFormatCustomProps, ref) => {
  const {
    onChange,
    startUnit,
    unit,
    type,
    arrowzero,
    ...others
  } = props;


  const notAllowedZero = (values: NumberFormatValues) =>
    values.value ? parseInt(values.value) > 0 : true;

  return (
    <NumberFormat
      {...others}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          currentTarget: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      isAllowed={!arrowzero ? notAllowedZero : undefined}
      thousandSeparator
      isNumericString
    />
  );
})


export default Input